export const STATE_STYLE = {
  Draft: "bg-[#E7DED7] text-[#332924]",
  Sent: "bg-sky-100 text-sky-800",
  Delivered: "bg-sky-100 text-sky-800",
  Opened: "bg-amber-100 text-amber-800",
  "In Progress": "bg-amber-100 text-amber-900",
  Completed: "bg-emerald-100 text-emerald-800",
  Revoked: "bg-rose-100 text-rose-800",
  Scoring: "bg-[#F3E4E0] text-[#7B2617]",
  "Needs Manual Scoring": "bg-rose-100 text-rose-800",
  "In Review": "bg-amber-100 text-amber-800",
  "Ready to Finalise": "bg-teal-100 text-teal-800",
};

export function Chip({ label, testId, tone }) {
  return (
    <span
      data-testid={testId}
      className={`inline-block px-2 py-0.5 rounded text-[10px] font-data uppercase tracking-wider ${
        tone || STATE_STYLE[label] || "bg-[#E7DED7] text-[#332924]"
      }`}
    >
      {label}
    </span>
  );
}

export function Spinner({ className = "w-4 h-4" }) {
  return (
    <span
      aria-hidden="true"
      className={`inline-block rounded-full border-2 border-[#DCD1C9] border-t-[#7B2617] animate-spin ${className}`}
    />
  );
}

/** Centred loader for a whole page or panel that has nothing to show yet. */
export function Loading({ label = "Loading…", testId = "loading" }) {
  return (
    <div
      className="h-full min-h-[180px] flex flex-col items-center justify-center gap-3 text-sm text-[#7A6D66]"
      role="status"
      aria-live="polite"
      data-testid={testId}
    >
      <Spinner className="w-6 h-6" />
      {label}
    </div>
  );
}

/** Shimmering placeholder rows, so a table keeps its shape while it loads. */
export function TableSkeleton({ cols = 5, rows = 6, testId = "table-skeleton" }) {
  return (
    <tbody data-testid={testId}>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={r} className="border-t border-[#E7DED7]">
          {Array.from({ length: cols }).map((__, c) => (
            <td key={c} className="px-3 py-3">
              <span
                className="block h-3 rounded bg-[#F1EAE4] animate-pulse"
                style={{ width: `${[70, 90, 50, 80, 60, 45][(r + c) % 6]}%` }}
              />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}

export function Panel({ title, children, actions, testId }) {
  return (
    <section className="border border-[#E7DED7] rounded-md bg-white" data-testid={testId}>
      <header className="px-4 py-2.5 border-b border-[#E7DED7] flex items-center justify-between gap-3">
        <h3 className="font-console text-xs uppercase tracking-wider text-[#6B5F59]">{title}</h3>
        {actions}
      </header>
      <div className="p-4">{children}</div>
    </section>
  );
}

export function Meter({ value }) {
  const v = Math.max(0, Math.min(100, Number(value) || 0));
  const tone = v >= 75 ? "#10B981" : v >= 60 ? "#F59E0B" : v >= 45 ? "#F97316" : "#EF4444";
  return (
    <div className="h-1.5 w-full bg-[#F1EAE4] rounded">
      <div className="h-1.5 rounded transition-all duration-500" style={{ width: `${v}%`, background: tone }} />
    </div>
  );
}
